<template>
    <b-card>
        <liquidations-table :items="liquidations" :loading="loading" show-search hide-payed-at />
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import LiquidationsTable from "@/views/accounting/billing/liquidations/components/LiquidationsTable.vue";

export default {
    name: "PendingLiquidationsList",
    components: {
        BCard,
        LiquidationsTable,
    },
    computed: {
        loading() {
            return this.$store.getters["liquidations/loading"];
        },
        liquidations() {
            return this.$store.getters["liquidations/liquidations"];
        },
    },
    created() {
        this.fetchLiquidations();
    },
    methods: {
        fetchLiquidations() {
            this.$store.dispatch("liquidations/fetchLiquidations");
        },
    },
};
</script>

<style lang="scss"></style>